import Cookies from 'js-cookie'

export enum ECookies {
  username = 'username',
  email = 'email',
  token = 'token',
  refreshToken = 'refreshToken',
  tokenVerifier = 'tokenVerifier',
  responovaSubmissionId = 'responovaSubmissionId',
  surveyType = 'surveyType',
  studyId = 'studyId',
  portraitId = 'portraitId',
  studyType = 'studyType',
  studyName = 'studyName',
  version = 'version',
  utmSource = 'utmSource',
  participantData = 'participantData',
  isQuestionPro = 'isQuestionPro',
  count = 'count',
  latLong = 'latLong',
  useWebOfflineParticipatV2 = 'useWebOfflineParticipatV2',
  tempPIN = 'tempPIN',
  forgotKey = 'forgotKey',
  changeProfileSource = 'changeProfileSource',
  showTNC = 'showTNC',
  partnerId = 'partnerId',
  withdrawMethod = 'withdrawMethod',
  permitOTP = 'permitOTP',
  payoutInfo = 'payoutInfo',
  accessTokenExpires = 'accessTokenExpires',
  responovaSession = 'responovaSession',
  unleashSessionId = 'unleashSessionId',
  responovaEncryptedCookie = 'responovaEncryptedCookie',
  isGuest = 'isGuest',
  authPartnerUrl = 'authPartnerUrl',
  sessionExpires = 'sessionExpires',
  deviceGUID = 'deviceGUID',
}

type CookieValue = string | undefined

type Cookies = {
  [key in ECookies]: CookieValue
}

function parseCookies(): Cookies {
  const cookies: Partial<Cookies> = {}
  Object.keys(ECookies).forEach((key) => {
    const cookieKey = key as ECookies
    cookies[cookieKey] = Cookies.get(cookieKey) ?? undefined
  })

  return cookies as Cookies
}

export default function useCookies() {
  const allCookies: Cookies = parseCookies()

  function set(name: ECookies, value: string, expires?: number) {
    const options: { domain?: string; secure: boolean; expires?: number } = {
      domain: process.env.NEXT_PUBLIC_COOKIES_DOMAIN,
      secure: process.env.NEXT_PUBLIC_COOKIES_DOMAIN !== 'localhost',
    }

    if (expires) {
      options.expires = expires
    }

    Cookies.set(name, value, options)
  }

  function remove(name: ECookies) {
    Cookies.remove(name, {
      domain: process.env.NEXT_PUBLIC_COOKIES_DOMAIN,
      secure: process.env.NEXT_PUBLIC_COOKIES_DOMAIN !== 'localhost',
    })
  }

  function removeAll() {
    Object.keys(ECookies).forEach((key) => {
      const cookieKey = key as ECookies
      Cookies.remove(cookieKey, {
        domain: process.env.NEXT_PUBLIC_COOKIES_DOMAIN,
        secure: process.env.NEXT_PUBLIC_COOKIES_DOMAIN === 'localhost',
      })
    })
  }

  return {
    ...allCookies,
    set,
    remove,
    removeAll,
  }
}
